import { createSlice } from '@reduxjs/toolkit';

import { ITouristState } from './interfaces';
import {
  loadTouristList,
  loadTouristItem,
  loadTouristReviews,
} from './actions';

export const touristSlice = createSlice({
  name: 'tourist',
  initialState: {
    list: [],
    reviews: [],
    item: {},
    limit: 20,
    total: 0,
    totalReviews: 0,
    offset: 0,
  } as ITouristState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadTouristList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadTouristItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
    builder.addCase(
      loadTouristReviews.fulfilled,
      (state, { payload: { data, total } }) => {
        state.reviews = data;
        state.totalReviews = total;
      }
    );
  },
});
